import {
  Box,
  Typography,
  Grid,
} from '@mui/material';
import { T, stitchPill, stitchCard } from './stitch';


// Quitclaim Card
function QuitclaimCard({ quitclaim }) {
  const name = quitclaim.fields?.Naam || 'Onbekend';
  const vergoeding = quitclaim.fields?.['Vergoeding?'] || '';
  const buyout = quitclaim.fields?.['Buy-out?'] || '';
  const gebied = quitclaim.fields?.['Geografisch gebied'] || '';
  const periode = quitclaim.fields?.Periode || '';
  const doeleinden = quitclaim.fields?.PublicatieDoeleinden || [];
  const status = quitclaim.fields?.Status || '';

  const statusColor = status === 'Getekend' ? T.emerald : status === 'Verstuurd' ? T.amber : T.outline;

  return (
    <Box sx={{ p: 2.5, ...stitchCard }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="subtitle2" sx={{ fontFamily: T.font, fontWeight: 600 }}>{name}</Typography>
        {status && (
          <Typography component="span" sx={stitchPill('#fff', statusColor)}>
            {status}
          </Typography>
        )}
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }} display="block">Vergoeding</Typography>
          <Typography component="span" sx={{
            ...stitchPill(
              vergoeding === 'Ja' ? '#166534' : vergoeding === 'Nee' ? T.error : T.outline,
              vergoeding === 'Ja' ? '#dcfce7' : vergoeding === 'Nee' ? T.errorBg : T.surfaceLow
            ),
            mt: 0.5,
          }}>
            {vergoeding || 'Niet ingesteld'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }} display="block">Buy-out</Typography>
          <Typography component="span" sx={{
            ...stitchPill(
              buyout ? '#92400e' : T.outline,
              buyout === 'Onbepaald' ? T.amberBg : buyout === 'Bepaald' ? '#dbeafe' : T.surfaceLow
            ),
            mt: 0.5,
          }}>
            {buyout || 'Niet ingesteld'}
          </Typography>
        </Grid>
        {gebied && (
          <Grid item xs={6}>
            <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }} display="block">Gebied</Typography>
            <Typography variant="body2" sx={{ fontFamily: T.fontBody }}>{gebied}</Typography>
          </Grid>
        )}
        {periode && (
          <Grid item xs={6}>
            <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }} display="block">Periode</Typography>
            <Typography variant="body2" sx={{ fontFamily: T.fontBody }}>{periode}</Typography>
          </Grid>
        )}
      </Grid>

      {doeleinden.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }} display="block" mb={0.5}>Publicatiedoeleinden</Typography>
          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
            {doeleinden.map((doel, idx) => (
              <Typography key={idx} component="span" sx={{ ...stitchPill(T.outline, 'transparent'), border: `1px solid ${T.outlineVariant}`, fontSize: '0.55rem' }}>
                {doel}
              </Typography>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default QuitclaimCard;
